import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Blog, { BlogDataType } from '@components/blog';

interface BlogIndexProps {
  prismicBlogIndex: BlogDataType | null;
}

const query = graphql`
  query BlogIndexQuery {
    prismicBlogIndex {
      ...BlogIndexData
    }
  }
`;

const BlogPage: React.FC = (): JSX.Element | null => {
  const { prismicBlogIndex }: BlogIndexProps = useStaticQuery(query);

  if (!prismicBlogIndex) {
    // Skip rendering if there is no blog index data available.
    return null;
  }

  return <Blog data={prismicBlogIndex.data} postsType="blog_post" />;
};

export default BlogPage;
